import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const PhotoShop = () => {
  return (
    <StartInterviewLayout type="photoshop"/>
  )
}

export default PhotoShop;